{{#SWITCH video_source}}
    {{#CASE 'youtube'}}
        <iframe
            title='YouTube video player'
            type='text/html'
            width='100%'
            height='95%'
            src='{{url}}'
            frameborder='0'
            style='aspect-ratio: 16/9;'
            allowFullScreen
        ></iframe>
    {{/CASE}}
{{/SWITCH}}
